
import { CustomLoading } from 'common'


export const ReportViewer = ({ useFetchInit }) =>{

    const {
        FetchData
    } = useFetchInit

    const { fetchTransactionsReport } = FetchData
    const { transactionReportBase64, loadingFetchAllTransactionsReport } = fetchTransactionsReport
    const { docName, docBase64 } = transactionReportBase64

    return(
        <>
            {(loadingFetchAllTransactionsReport)&&(<CustomLoading/>)}
            {(!loadingFetchAllTransactionsReport && (docBase64 || docBase64 !== ''))&&(
                <iframe
                    src={docBase64 || null}
                    width="100%"
                    height="700"
                    style={{ border: "none" }}
                    title={docName}
                />
            )}
        </>
    )
}